import { getSelectedNode } from "@builder/store/slices/BuilderSlice/builderSelectors";
import { updateNodeProperty } from "../../../../store/slices/BuilderSlice/builderSlice";
import { useAppDispatch, useAppSelector } from "../../../../store/store";
import SidebarCollapse from "../../../app/SidebarCollapse";
import ColorInput from "../../../general/ColorInput";
import { EditableProps } from "../../editableProps";
import { getStyle, getStylePath } from "@builder/components/editable/helpers";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { setCurrentPopup, setImageState } from "@builder/store/slices/popupSlice";
import RadioInput from "@builder/components/general/RadioInput";
import SelectImage from "@builder/components/general/SelectImage";
import DynamicDataSelectorInput from "@builder/components/general/DynamicSelectorInput";

const Background: React.FC<EditableProps> = ({ parent, title, path, noWrapper, stateMode }: EditableProps) => {
    const dispatch = useAppDispatch();
    const node = useAppSelector(getSelectedNode);
    const cvMode = useAppSelector(state => state.builder.conditionalVariationMode);
    const cvModeIndex = cvMode?.id === node?.id ? cvMode.index : null;
    const [imageType, setImageType] = useState<string>(node?.dynamicData ? "db" : "static");
    const { t } = useTranslation();

    const imageTypeOptions = [
        {
            value: "static",
            img: "/image-icon-thin.svg",
            checked: imageType === "static",
            disabled: !!node?.dynamicData,
            tooltip: t("generalComponents.radioInput.Static")
        },
        { value: "db", img: "/db-icon.svg", checked: imageType === "db", tooltip: t("generalComponents.radioInput.Dynamic") }
    ];

    const imageTypeCallback = (value: string): void => {
        setImageType(value);
    };

    const imageCallback = () => {
        dispatch(setImageState(["backgroundImage"]));
        dispatch(setCurrentPopup("images"));
    };

    const removeImageCallback = () => {
        dispatch(updateNodeProperty({ propertyPath: ["backgroundImage"], value: "", remove: true }));
    };

    if (!node) return null;

    const styles = getStyle(node, path, stateMode, cvModeIndex);
    const stylePath = getStylePath(path, stateMode, cvModeIndex);

    const backgroundColor = styles.stateStyle?.backgroundColor || styles.default?.backgroundColor;
    const backgroundColorCallback = (value: string) => {
        dispatch(
            updateNodeProperty({
                propertyPath: [...stylePath, "backgroundColor"],
                value
            })
        );
    };

    if (noWrapper) {
        return <ColorInput title="Background Color" color={backgroundColor} callback={backgroundColorCallback} />;
    } else {
        return (
            <SidebarCollapse title={title || "Background"} parent={parent}>
                <ColorInput title="Background Color" color={backgroundColor} callback={backgroundColorCallback} />
                <RadioInput groupName="textType" options={imageTypeOptions} callback={imageTypeCallback}></RadioInput>
                {imageType === "static" ? (
                    <SelectImage type="image" callback={imageCallback} removeCallback={removeImageCallback} img={node?.backgroundImage} />
                ) : (
                    <DynamicDataSelectorInput />
                )}
            </SidebarCollapse>
        );
    }
};

export default Background;
